"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * (c) 2022, Micro:bit Educational Foundation and contributors
 *
 * SPDX-License-Identifier: MIT
 */
const common_sizes_1 = require("./common-sizes");
const space = Object.assign({}, common_sizes_1.default);
exports.default = space;
